import { Navigate, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../context/AuthContext';
import { StartupScreen } from '../brand/StartupScreen';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

export function ProtectedRoute({ children }: ProtectedRouteProps) {
  const { t } = useTranslation('common');
  const { isAuthenticated, loading, reconnecting, needsOnboarding, needsTelegram } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <StartupScreen label={t('loading')}>
        {reconnecting && <p role="status">{t('reconnecting')}</p>}
      </StartupScreen>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // A User who owes a Telegram connection makes it before anything else, onboarding included.
  if (needsTelegram) {
    return <Navigate to="/connect-telegram" replace />;
  }

  // New users are sent through onboarding first. The /onboarding route itself is
  // not wrapped in ProtectedRoute, so this never loops.
  if (needsOnboarding) {
    return <Navigate to="/onboarding" replace />;
  }

  return <>{children}</>;
}
